import PromoListComponent from '../../promotion/PromoListComponent';

const PomoCustomer = () => {
console.log("PomoCustomer");
  return (  
      <PromoListComponent
        route={`/dashboard/PromotionDashboard`}
      />
  ); 
};

export default PomoCustomer;
 